import { PipeTransform, Pipe } from "@angular/core"

@Pipe({
  name: 'filterRequests'
})
export class FilterRequestList implements PipeTransform {
  transform(value: any[], desiredStates: string[]): any[] {
    const values = value.slice()
    const result = values.filter(val => {
      return !desiredStates || desiredStates.includes(val.state)
    }).sort((a, b) => {
      return b.state >= a.state ? 1 : -1
    }).reverse()
    if (result.length > 0) return result
    return null
  }
}
